import {
  genericOAuthClient,
  organizationClient,
  phoneNumberClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: `${process.env.VITE_API_BASE || ''}/auth`,
  plugins: [phoneNumberClient(), organizationClient(), genericOAuthClient()],
});
